import Marquee from "react-fast-marquee";
import { PHOTOS } from "@/data/content";

const IMAGES = [
  { src: PHOTOS.pressHatSeated, alt: "Susan Grau — signature hat portrait" },
  { src: PHOTOS.hero, alt: "Susan Grau portrait" },
  { src: PHOTOS.pressGoopStage, alt: "Susan Grau speaking on stage at In Goop Health" },
  { src: PHOTOS.withValerie, alt: "Susan Grau with Valerie Bertinelli" },
  { src: PHOTOS.pressSigningFlowers, alt: "Susan Grau at an Infinite Life, Infinite Lessons book signing" },
  { src: PHOTOS.pressHatPalm, alt: "Susan Grau editorial portrait with hat" },
  { src: PHOTOS.drewNyc, alt: "Susan Grau in New York outside The Drew Barrymore Show" },
  { src: PHOTOS.pressFloralDress, alt: "Susan Grau portrait" },
  { src: PHOTOS.pressSigningReader, alt: "Susan Grau signing books for a reader" },
  { src: PHOTOS.coverStar, alt: "Susan Grau at an Infinite Life, Infinite Lessons event" },
  { src: PHOTOS.pressWhiteJacket, alt: "Susan Grau editorial portrait" },
  { src: PHOTOS.bio, alt: "Susan Grau signing books" },
  { src: PHOTOS.pressWithDog, alt: "Susan Grau at home" },
  { src: PHOTOS.holdingBook, alt: "Susan Grau holding her bestseller", pos: "object-[center_68%]" },
  { src: PHOTOS.drewSet, alt: "Susan Grau on the Drew set" },
];

export default function GalleryRow() {
  return (
    <section data-testid="gallery-row" className="overflow-hidden border-y border-[#6B5D4F]/10 py-20 lg:py-28">
      <div className="mb-12 flex items-end justify-between px-6 lg:px-16">
        <div>
          <p className="font-body text-[0.65rem] font-medium uppercase tracking-[0.5em] text-[#C5A059]">
            The Gallery
          </p>
          <h2 className="mt-3 font-display text-4xl font-light tracking-tighter text-[#6B5D4F] md:text-5xl">
            Susan, <span className="italic text-[#C5A059]">In Focus</span>
          </h2>
        </div>
        <p className="hidden font-body text-[0.6rem] font-medium uppercase tracking-[0.35em] text-[#8B7D6B] md:block">
          Always in motion
        </p>
      </div>

      <Marquee speed={34} gradient={false} pauseOnHover>
        {IMAGES.map((img, i) => (
          <div key={i} data-testid={`gallery-item-${i}`} className="group mx-4">
            <div className="h-[52vh] overflow-hidden border border-[#C5A059]/40 p-2 transition-colors duration-500 group-hover:border-[#C5A059] md:h-[62vh]">
              <img
                src={img.src}
                alt={img.alt}
                className={`aspect-[3/4] h-full object-cover transition-transform duration-700 group-hover:scale-105 ${img.pos || "object-top"}`}
                loading="lazy"
              />
            </div>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
